<template>
  <div>
  
  
<div>
 <h4 slot="header" class="card-title" style="font-weight:bold;">
     My Details
    </h4>
</div>
  
 <card class="form-horizontal">
   
    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">First Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="first_name"
                  v-validate="modelValidations.first_name"
                  :error="getError('first_name')"
                   data-vv-scope="user_profile"
                  v-model="model.first_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Last Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="last_name"

                  v-model="model.last_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
  
    
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Nationality</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="nationality"

                  v-model="model.nationality">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">ID Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="gov_id"

                  v-model="model.gov_id">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
     <div class="row">
      <label class="col-sm-2 col-form-label">ID Type</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.gov_id_type">
                    <el-option v-for="option in selects.gov_id_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
  
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Contact Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="contact_num"
                  v-validate="modelValidations.contact_num"
                  :error="getError('contact_num')"
                  v-model="model.contact_num">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

	 <div class="row">
      <label class="col-sm-2 col-form-label">Address</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="address_1"
                 
                  v-model="model.address_1">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
 	<div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">My Title</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="title"
                  v-model="model.title">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>



   

  </card>
 <div slot="footer" class="text-center">
      <p-button type="info" @click.prevent="editMe">Edit My Details</p-button>
    </div>
   
   
   
           
<div>
 <h4 slot="header" class="card-title" style="font-weight:bold;margin-top:50px;">
     Organization Details
    </h4>
</div>    
        
<card  class="form-horizontal">


    
    
	
	<div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Company Name</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_name"
                  v-validate="modelValidations.company_name"
                  :error="getError('company_name')"
                   data-vv-scope="coy_profile"
                  v-model="org.company_name">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Company UEN</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="company_uen"
                  v-model="org.company_uen">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Office Number</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="office_num"
                  v-model="org.office_num">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
      
    <div class="row">
      <label class="col-sm-2 col-form-label">Office Address</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="org.address_1"
                  v-model="org.address_1">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
	
</card>





 <div slot="footer" class="text-center">
      <p-button  type="info" @click.prevent="editOrg">Edit Organization Details</p-button>
    </div>
   


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     
     
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/entities/get/me';
   
			 ApiService.get(uri).then(response => {
				
				if(response.data.me){
					this.model = response.data.me;
					
			    }
			    if(response.data.org){
			    	this.org = response.data.org;
			    }
			
			})

    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	createForm: true,
    	displayCompanyForm: false,
    	org:{
    	  company_name:'',
          company_uen:'',
          address_1:'',
    	  office_num:'',
    	
    	},
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_company: 2,
          date_appt: '',
          position:'Director',
          nationality:'',
          gov_id:'',
          gov_id_type:1,
          email:'',
          contact_num:'',
          eid: this.$route.params.eid,
         
          effective_date:'',

        },
        modelValidations: {
          first_name: {
            required: true
          },
          last_name: {
            required: true,
          },
          address_1: {
            required: true,
          },
          status: {
          	required: true,
          },
          is_contact_person: {
            required: true,
          },
          effective_date: {
            required: true,
          },
           position: {
            required: true,
          },
          nationality: {
            required: true,
          },
          gov_id: {
            required: true,
          },
          email: {
            required: true,
            email: true
          },
          contact_num: {
            required: true,
          },
            company_name: {
            required: true
          },
          
        },
        
        selects: {
          gov_id_type: [
            {value: 1, label: 'Government ID'},
            {value: 2, label: 'Passport'},
		   ],
		  is_company:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ] 
        },
      }
    },
    methods:{
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
       createEntity: function () {
       
       },
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      submitNewPersonForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/create_person';
      		ApiService.post(uri, this.model).then(response => {
      	
         			this.$router.push( '/cs_dashboard')
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editMe() {
        this.$validator.validateAll("user_profile").then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/update/me';
      		ApiService.post(uri, this.model).then(response => {
      	
         			this.$router.push('/cs_dashboard')
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      editOrg() {
        this.$validator.validateAll("coy_profile").then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/update/org';
      		ApiService.post(uri, this.org).then(response => {
      	
         			this.$router.push('/cs_dashboard')
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


